require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-the-dr-congo-country-forest-note-how-about-a-little.json") })
        }
      }, "path---en-us-update-the-dr-congo-country-forest-note-how-about-a-little");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-the-dr-congo-country-forest-note-how-about-a-little!./.cache/json/en-us-update-the-dr-congo-country-forest-note-how-about-a-little.json
// module id = 799
// module chunks = 231608221292675